import { makeStyles } from "@material-ui/core/styles";
import {
  MODUS_FIELD_BG_DISABLED,
  MODUS_FIELD_BORDER_ENABLED,
  MODUS_FIELD_BORDER_ERROR,
  MODUS_FIELD_TEXT_DISABLED,
} from "../field-common/formFieldTokens";

export const useModusTextFieldStyles = makeStyles(() => ({
  root: {
    width: "100%",
    margin: "7px 0",
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "8px",
  },
  labelGroup: {
    display: "flex",
    alignItems: "baseline",
    flexWrap: "wrap",
    gap: 0,
  },
  label: {
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: 600,
    color: "#0e2c37",
  },
  labelDisabled: {
    fontWeight: 700,
    color: "#595959",
  },
  requiredMark: {
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: 400,
    color: "#AB1F26",
    marginLeft: "2px",
  },
  charCount: {
    fontSize: "12px",
    lineHeight: "18px",
    color: "#6A6E79",
    flexShrink: 0,
    marginLeft: "8px",
  },
  charCountDisabled: {
    color: "#b3b6bc",
  },
  fieldShell: {
    borderRadius: "4px",
    border: `1px solid ${MODUS_FIELD_BORDER_ENABLED}`,
    backgroundColor: "#FFFFFF",
    boxShadow: "none",
    outline: "none",
    transition: "border-color 0.15s ease",
    display: "flex",
    alignItems: "center",
    minHeight: "48px",
  },
  fieldShellError: {
    borderColor: MODUS_FIELD_BORDER_ERROR,
  },
  fieldShellDisabled: {
    backgroundColor: MODUS_FIELD_BG_DISABLED,
    border: "none",
    boxShadow: "none",
    "&:focus-within": {
      boxShadow: "none",
    },
  },
  input: {
    flex: 1,
    width: "100%",
    minWidth: 0,
    height: "48px",
    padding: "0 12px",
    fontFamily: "inherit",
    fontSize: "14px",
    lineHeight: "22px",
    color: "#171C1E",
    backgroundColor: "transparent",
    border: "none",
    outline: "none",
    boxSizing: "border-box",
    borderRadius: "4px",
  },
  inputDisabled: {
    color: MODUS_FIELD_TEXT_DISABLED,
    cursor: "default",
    opacity: 1,
    WebkitTextFillColor: MODUS_FIELD_TEXT_DISABLED,
  },
  helper: {
    marginTop: "4px",
    fontSize: "12px",
    lineHeight: "18px",
    color: "#AB1F26",
  },
}));
